import React from "react";
import Slider from "react-slick";
import { Box } from "@mui/material";
import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import CardProduct from "../CardProduct";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const RelatedProductsSlider = ({ relatedProducts }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        padding: { xs: "20px 5px", md: "20px 10px" },
        "& .slick-dots": {
          bottom: "-35px",
          "& li button:before": {
            fontSize: "10px",
            color: "#D87390",
          },
          "& li.slick-active button:before": {
            color: "#9A457F",
          },
        },
      }}
    >
      <Slider {...settings}>
        {relatedProducts &&
          relatedProducts.map((product, index) => (
            <Box key={index} sx={{ padding: "0 8px" }}>
              <CardProduct product={product} slider={true} />
            </Box>
          ))}
      </Slider>
    </Box>
  );
};

// Custom Next Arrow
const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #9A457F 0%, #D87390 100%)",
        borderRadius: "50%",
        right: "-20px",
        zIndex: 10,
        border: "3px solid #fff",
        height: "48px",
        width: "48px",
        boxShadow: "0 4px 16px rgba(154, 69, 127, 0.3)",
        transition: "all 0.3s ease",
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.1)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(154, 69, 127, 0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(154, 69, 127, 0.3)";
      }}
    >
      <ArrowForwardIos
        style={{
          fontSize: "18px",
          color: "white",
        }}
      />
    </div>
  );
};

// Custom Prev Arrow
const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #9A457F 0%, #D87390 100%)",
        borderRadius: "50%",
        left: "-20px",
        zIndex: 10,
        border: "3px solid #fff",
        height: "48px",
        width: "48px",
        boxShadow: "0 4px 16px rgba(154, 69, 127, 0.3)",
        transition: "all 0.3s ease",
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.1)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(154, 69, 127, 0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(154, 69, 127, 0.3)";
      }}
    >
      <ArrowBackIosNew style={{ fontSize: "18px", color: "white" }} />
    </div>
  );
};

export default RelatedProductsSlider;
